import { render, staticRenderFns } from "./PageSidebar.vue?vue&type=template&id=2320cf5c&"
import script from "./PageSidebar.vue?vue&type=script&lang=js&"
export * from "./PageSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PageSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports